<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">Česta pitanja / FAQ</h2>
            <div>
              <p>
                Kako bismo olak&scaron;ali snalaženje na na&scaron;em web shopu, odgovorili smo na
                va&scaron;a najče&scaron;ća pitanja. Vjerujemo da će vam odgovori pomoći kako biste
                &scaron;to lak&scaron;e, brže i bez nedoumica izvr&scaron;ili narudžbu željenog
                proizvoda.
              </p>
              <p><strong>Kako se registrirati i napraviti profil?</strong></p>
              <p><strong>Za poslovne kupce:</strong></p>
              <p>
                Kada otvorite na&scaron; web shop trebat ćete zatražiti korisnički račun
                popunjavanjem traženih informacija. Nakon toga, na&scaron; tim će vas kontaktirati u
                najkraćem roku, te ćemo vam izraditi korisnički račun. Podaci koje trebate popuniti
                su: ime i prezime, kompanija, telefon, adresa, država, grad i interesna područja.
                Kada su u pitanju interesna područja, bitno je da označite onaj sektor kojem
                pripadate i kojim se bavite, bilo da su to zdravstvene ustanove, ugostiteljstvo,
                teretane, proizvodnja ili drugo ponuđeno.
              </p>
              <p><strong>Za privatne kupce:</strong></p>
              <p>
                Možete kupovati bez pravljenja korisničkog računa, dakle kao gost. Potrebno je samo
                da unesete svoje podatke za dostavu, kao i email kako bismo vam mogli poslati
                potvrdu uspje&scaron;ne kupovine. Prijaviti se možete i preko Facebook i Google
                platformi koje su ponuđene.
              </p>
              <p><strong>Kako naručiti proizvode?</strong></p>
              <p><strong>Za poslovne kupce:</strong></p>
              <p>
                Naručivanje je vrlo jednostavno, otvorite artikl koji želite naručiti, kliknete 'u
                ko&scaron;aricu', ili na brzom pregledniku kliknete odgovarajuću ikonicu koja se
                nalazi u desnom uglu slike. Kada zavr&scaron;ite sa dodavanjem artikala, otvorite
                korpu i idite na naplatu. Izaberite adresu za dostavu, način dostave i način
                plaćanja. Na kraju kliknete 'zaključi narudžbu' i samim time va&scaron;a narudžba je
                poslana. Na va&scaron;u email adresu stiže potvrda o izvr&scaron;enoj narudžbi.
              </p>
              <p><strong>Za privatne kupce:</strong></p>
              <p>
                Otvorite artikl koji želite naručiti i dodajte ga u ko&scaron;aricu. Kada
                zavr&scaron;ite sa dodavanjem artikala, otvorite korpu i idite na naplatu. Ispunite
                podatke koji se traže od vas, a to su: ime i prezime, adresa, e-mail adresa, broj
                telefona i način plaćanja. Na kraju kliknete 'zaključi narudžbu' i samim time
                va&scaron;a narudžba je poslana. Na va&scaron;u email adresu stiže potvrda o
                izvr&scaron;enoj narudžbi.
              </p>
              <p><strong>Kako se vr&scaron;i dostava?</strong></p>
              <p><strong>Za poslovne kupce:</strong></p>
              <p>Poslovni kupci imaju vi&scaron;e opcija dostave, a to su:</p>
              <ul>
                <li>Eurosan besplatna dostava</li>
                <li>dostava brzom po&scaron;tom (Hrvatska po&scaron;ta Mostar)</li>
                <li>
                  lično preuzimanje u gradovima Mostar, Sarajevo i Banja Luka, odnosno u firmama
                  Grupe
                </li>
              </ul>
              <p><strong>Za privatne kupce:</strong></p>
              <p>
                Dostava se vr&scaron;i brzom po&scaron;tom. (Hrvatska Po&scaron;ta Mostar uz vrijeme
                isporuke od 24h)
              </p>
              <p>
                Također, kupci mogu osobno preuzeti narudžbu u jednoj od na&scaron;ih poslovnica u
                Mostaru, Sarajevu ili Banja Luci.
              </p>
              <p><strong>Da li su va&scaron;i proizvodi pogodni za male biznise?</strong></p>
              <p>
                Da, na&scaron;i proizvodi su pogodni za velike kompanije, male biznise i preduzeća,
                kao i privatne korisnike i domaćinstva.
              </p>
              <p>
                <strong
                  >Da li nudite prezentacije, trening ili podr&scaron;ku za va&scaron;e
                  proizvode?</strong
                >
              </p>
              <p><strong>Poslovni kupci:</strong></p>
              <p>
                Poslovni kupci imaju opciju prezentacije proizvoda za određene proizvode poput
                ma&scaron;ina za či&scaron;ćenje, određenog kemijskog programa, pomagala za
                či&scaron;ćenje i sl. Za svaki kupljeni proizvod, kupci će imati trening gdje će
                na&scaron;i stručnjaci objasniti na koji način koristiti određeni proizvod. Također,
                na web shopu u sklopu svakog artikla se nalazi tehnička dokumentacija i način
                kori&scaron;tenja proizvoda. Svaki kupac ima svog prodajnog predstavnika koji mu je
                tu kao podr&scaron;ka pri kori&scaron;tenju proizvoda.
              </p>
              <p>
                Za sve nejasnoće, poslovni kupci uvijek mogu kontaktirati na&scaron; besplatni info
                telefon <strong>080 080 080 ili poslati nam e-mail na </strong
                ><a href="mailto:webshop@eurosan.ba"><strong>webshop@eurosan.ba</strong></a
                ><strong>.</strong>
              </p>
              <p><strong>Privatni kupci:</strong></p>
              <p>
                Privatni kupci nam se putem besplatnog info telefona
                <strong>080 080 080</strong> ili putem drugih kanala komunikacije, uvijek mogu
                obratiti za pomoć, savjet i pravilan izbor proizvoda za njihovu potrebu u privatne
                svrhe i domaćinstvo. Korisnička podr&scaron;ka je uvijek dostupna.
              </p>
              <p><strong>Koje kreditne kartice primate?</strong></p>
              <p>
                Pored plaćanja gotovinom pouteću, privatni kupci imaju opciju plaćanja i VISA,
                MasterCard i Maestro karticama.
              </p>
              <p><strong>Da li dostavljate proizvode van BiH?</strong></p>
              <p>
                Ne. Na&scaron;e trži&scaron;te je lokalno i obuhvaća samo teritoriju Bosne i
                Hercegovine. Međutim, tu su na&scaron;e dvije partnerske firme, Interesta d.o.o. u
                Crnoj Gori i Ecotime d.o.o. Beograd u Srbiji. Za dodatne informacije, budite nas
                slobodni kontaktirati.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FAQ',
  metaInfo() {
    return {
      title: 'Najcesce postavljana pitanja - Eurosan',
      meta: [
        { name: 'description', content: 'Novosti iz svijeta Eurosan grupacije.' },
      ],
    };
  },
};
</script>
